import { http } from '../index'

async function putProfileLocale(data) {
	return http.put(`/change-locale`, { locale: data }).then((response) => response.data)
}

export { putProfileLocale }
